import { MAIN_GOOGLE_MAP_ID } from '~/_shared/components/google-map/google-map.component';
import { useGetGoogleMapInstance } from '~/_shared/components/google-map/useGetGoogleMapInstance.hook';
import { useGetWebGLOverlayInstance } from './map/webgl/useGetWebGLOverlayInstance.hook';

export const usePreloadMapAndWebGL = () => {
  const googleMapInstance = useGetGoogleMapInstance({
    id: MAIN_GOOGLE_MAP_ID,
    useIdAsMapId: false,
  });
  useGetWebGLOverlayInstance(googleMapInstance);
};
